import { render, staticRenderFns } from "./ProductAddToCartText.vue?vue&type=template&id=7808d1f6&"
import script from "./ProductAddToCartText.vue?vue&type=script&lang=ts&"
export * from "./ProductAddToCartText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports